import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SubCaptar from './sub-captar';
import SubCaptarDetail from './sub-captar-detail';
import SubCaptarUpdate from './sub-captar-update';
import SubCaptarDeleteDialog from './sub-captar-delete-dialog';

const SubCaptarRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SubCaptar />} />
    <Route path="new" element={<SubCaptarUpdate />} />
    <Route path=":id">
      <Route index element={<SubCaptarDetail />} />
      <Route path="edit" element={<SubCaptarUpdate />} />
      <Route path="delete" element={<SubCaptarDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SubCaptarRoutes;
